<template>
  <div ref="element" class="card stroke-m neutral-50 outlined">
    <div v-if="showControls" class="controls">
      <button
        type="button"
        class="button-close"
        aria-label="close"
        @click="close"
      >
        <icon name="material-symbols-light:close-small-rounded" size="2.4rem" />
      </button>
    </div>
    <div class="image-top" :style="styleImage">
      <ImgLoad :src="imgSrc" :alt="imgAlt" effect="scale-and-fade" />
    </div>
    <div class="content" :style="styleContent">
      <header ref="elementHeader" class="header">
        <heading tag="h4" class="title"><slot name="title" /></heading>
      </header>

      <slot />
      <footer ref="elementFooter" class="footer">
        <slot name="footer" />
      </footer>
    </div>
  </div>
</template>
<script setup lang="ts">
interface Props {
  imgAlt: string;
  imgSrc: string;
  styleImage: any;
  styleContent: any;
  closeClickOutside?: boolean;
  showControls?: boolean;
  closeTimer?: number;
}
const props = defineProps({
  imgAlt: null,
  imgSrc: null,
  styleImage: null,
  styleContent: null,
  closeClickOutside: { type: Boolean, default: false },
  showControls: { type: Boolean, default: false },
  closeTimer: { default: -1 }
});

const element = ref(null);

const emit = defineEmits(["close"]);

const { close } = useDialogControls(element, props, emit);
</script>
<style lang="scss" scoped>
.card {
  position: relative;
  padding: 2rem;
}
.content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: var(--gap_l);
}

.image-top {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -50%);
}

header {
  .title {
    color: var(--color_secondary);
    text-align: center;
    text-transform: uppercase;
  }
}

footer {
  display: flex;
  justify-content: center;
  width: 100%;
}

.controls {
  display: flex;
  position: absolute;
  z-index: 2;
  top: 0.5rem;
  right: 0.5rem;
  flex-direction: row-reverse;
  width: 100%;
}

.button-close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.8rem;
  height: 1.8rem;
  overflow: hidden;
  transform: translate(0, 0);
  transition: transform 500ms $ease-out-quad, box-shadow 200ms $ease-in-quad;
  border-radius: 50%;
  background-color: var(--color_error);
  color: var(--color_neutral_25);
  &:hover,
  &:focus {
    transform: rotate(180deg);
  }
}
</style>
